import React from "react";

export function TabBtn({ active, onClick, icon: Icon, label, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`flex-1 px-6 py-4 flex items-center justify-center gap-2 text-xs uppercase tracking-[0.2em] font-bold transition-colors ${
        active ? "bg-primary-brand text-white" : "bg-brand-bg text-slate-600 hover:text-slate-900"
      }`}
    >
      <Icon className="h-4 w-4" /> {label}
    </button>
  );
}

export function EmptyState({ label }) {
  return <div className="py-16 text-center text-slate-500 text-sm">{label}</div>;
}

export const adminInputCls = "w-full bg-transparent border border-slate-200 focus:border-primary-brand outline-none px-3 py-2.5 text-sm text-slate-900";
